import React from "react";
import { Info, X } from "lucide-react";

// The ⓘ beside a question title, and the panel it opens. The panel sits in the
// flow between the title and the answer, so it can never cover the field it is
// explaining — the same behaviour on a phone as on a desktop, with no hover
// dependency. Opening, closing and "only one at a time" live in Questionnaire.
export const HelpIcon = ({ qKey, help, open, onToggle }) => {
  if (!help || !help.enabled) return null;
  return (
    <button
      type="button"
      onClick={() => onToggle(open ? null : qKey)}
      aria-expanded={open}
      aria-controls={`pkg-help-${qKey}`}
      aria-label={help.heading ? `${help.heading} — more about this question` : "More about this question"}
      data-testid={`package-help-icon-${qKey}`}
      className={`inline-flex items-center justify-center w-5 h-5 shrink-0 rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-orange/50 ${
        open ? "bg-navy text-white border-navy" : "bg-white text-slate-400 border-slate-300 hover:text-navy hover:border-navy"
      }`}
    >
      <Info size={12} strokeWidth={2.5} />
    </button>
  );
};

export const HelpPanel = ({ qKey, help, onClose }) => {
  const items = help?.items || [];
  if (!help) return null;
  return (
    <div
      id={`pkg-help-${qKey}`}
      role="note"
      data-testid={`package-help-panel-${qKey}`}
      className="mt-2 rounded-xl border border-navy/15 bg-navy/[0.03] p-3.5"
    >
      <div className="flex items-start justify-between gap-3">
        {help.heading && <p className="text-xs font-bold text-navy leading-snug">{help.heading}</p>}
        <button
          type="button"
          onClick={onClose}
          aria-label="Close this help"
          data-testid={`package-help-close-${qKey}`}
          className="text-slate-400 hover:text-navy shrink-0 rounded focus:outline-none focus:ring-2 focus:ring-orange/50"
        >
          <X size={14} />
        </button>
      </div>
      {help.text && <p className="text-xs text-slate-600 leading-relaxed mt-1.5">{help.text}</p>}
      {items.length > 0 && (
        <dl className="mt-2.5 space-y-2">
          {items.map((it) => (
            <div key={it.label || it.text}>
              <dt className="text-xs font-bold text-navy">{it.label}</dt>
              <dd className="text-xs text-slate-600 leading-relaxed">{it.text}</dd>
            </div>
          ))}
        </dl>
      )}
      {help.footer && <p className="text-xs text-slate-500 leading-relaxed mt-2.5 italic">{help.footer}</p>}
    </div>
  );
};
